import React from 'react';
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import Settings from "components/settings";
import { LanguagePage, LanguagesPage, TranslationAiRequestsPage, TranslationAiUsagePage } from "components/pages/settings";

export default function SettingsRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Redirect to={ Settings.Const.translationAiUsagePath } />
            </Route>
            <Route path={ `${ path }/languages` } exact>
                <LanguagesPage />
            </Route>
            <Route path={ `${ path }/languages/page/:pageNum` } exact>
                <LanguagesPage />
            </Route>
            <Route path={ `${ path }/languages/create` } exact>
                <LanguagePage isCreate />
            </Route>
            <Route path={ `${ path }/languages/:id` } exact>
                { ({ match }) => <LanguagePage match={ match } /> }
            </Route>
            <Route path={ `${ path }/translation-ai-usage` } exact>
                <TranslationAiUsagePage />
            </Route>
            <Route path={ `${ path }/translation-ai-usage/page/:pageNum` } exact>
                <TranslationAiUsagePage />
            </Route>
            <Route path={ `${ path }/translation-ai-requests` } exact>
                <TranslationAiRequestsPage />
            </Route>
            <Route path={ `${ path }/translation-ai-requests/page/:pageNum` } exact>
                <TranslationAiRequestsPage />
            </Route>
        </Switch>
    );
}
